import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DataService as CoreDataService, QueryColumn } from '@barthauer/abc/core/data';
import {
  AbcAccordionComponent,
  AbcPopupComponent,
  AbcSpeedDialActionComponent,
  _AbcButtonComponent,
  _AbcContextMenuComponent,
  _AbcFileUploaderComponent,
  _AbcGridComponent,
  _AbcSelectBoxComponent,
} from '@barthauer/abc/ui-components';
import { DefaultIcons, DocumentKind, GeoDsDocument, Project } from '@barthauer/custom/xmt-models';
import {
  DxButtonModule,
  DxDataGridModule,
  DxFileUploaderModule,
  DxFormModule,
  DxPopupModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxTextBoxModule,
} from 'devextreme-angular';
import { Column } from 'devextreme/ui/data_grid';
import { Observable, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { NotificationMessage, PermessionType, ToastType } from '../../models/enumeration-list.model';
import { AppService } from '../../services/app.service';
import { DataService, ObjectKeys } from '../../services/data.service';
import { NotificationService } from '../../services/notification.service';
import { SharedModule } from '../shared.module';
import { DocumentService } from './document.service';
import { CheckPermissionDirective } from '../../directives/check-permession-directive';
@Component({
  selector: 'ubt-geods-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    SharedModule,
    DxScrollViewModule,
    DxPopupModule,
    DxButtonModule,
    DxSelectBoxModule,
    DxScrollViewModule,
    DxTextBoxModule,
    DxFormModule,
    DxDataGridModule,
    DxFileUploaderModule,
    DxSelectBoxModule,
    AbcAccordionComponent,
    _AbcSelectBoxComponent,
    AbcSpeedDialActionComponent,
    _AbcGridComponent,
    _AbcButtonComponent,
    AbcPopupComponent,
    _AbcFileUploaderComponent,
    _AbcContextMenuComponent,
    CheckPermissionDirective
  ],
})
export class DocumentComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('documentsGrid') documentsGrid: _AbcGridComponent;
  @ViewChild('addDocumentSelectBox') addDocumentSelectBox: _AbcSelectBoxComponent;
  @ViewChild('addDocumentPopup') addDocumentPopup: AbcPopupComponent;
  @ViewChild('fileUploader') fileUploader: _AbcFileUploaderComponent;
  @ViewChild('deleteDocumentConfirmationPopup') deleteConfirmationPopup: AbcPopupComponent;
  @ViewChild('filterProjectList') filterProjectList: _AbcSelectBoxComponent;
  @ViewChild('contextMenu') contextMenu: _AbcContextMenuComponent;

  @Input() showAllDocuments = true;
  @Input() documentOpath = false;
  @Input() parentId: string;
  @Input() designation: string;
  @Input() documents: GeoDsDocument[] = [];
  public uploadDocument: GeoDsDocument = new GeoDsDocument(null);
  public documentsColumnsHeader: Column[] = [];
  public columns: QueryColumn[] = [];
  public projectList: Project[] = [];
  private subscriptions: Subscription[] = [];
  public document: GeoDsDocument = new GeoDsDocument(null);
  private opath = '';
  public Action = PermessionType
  public readonly documentbyIdColumns: QueryColumn[] = [
    this.coreDataService.createQueryColumn('Id', 'Id'),
    this.coreDataService.createQueryColumn('FileName', 'FileName'),
    this.coreDataService.createQueryColumn('Object', 'Object'),
  ];
  public noDataText = this.dataService.res('Ubt-No-Data-text');
  public documentTitle!: String;
  public searchLabel: String;
  public isReset: boolean = false;
  public allDocuments: GeoDsDocument[] = [];
  public contextMenuItems: any[] = [
    {
      text: this.dataService.res('Ubt-Documents-Preview-Document'),
      onClick: (event) => {
        this.dataService.previewDocument(this.document);
      },
    },
    {
      text: this.dataService.res('Ubt-Documents-Download-Document'),
      onClick: () => {
        this.downloadDocument(this.document['Id']);
      },
    },
    {
      text: this.dataService.res('Ubt-Documents-Delete-Document'),
      onClick: () => {
        this.openDeleteConfirmationDialog();
      },
    },
  ];
  private measureDocumentList: string[] = []
  constructor(
    public dataService: DataService,
    private appService: AppService,
    private coreDataService: CoreDataService,
    private documentService: DocumentService,
    private cdr: ChangeDetectorRef,
    private notificationService: NotificationService
  ) {
    this.documentTitle = this.dataService.res('Ubt-TreeList-Documents');
    this.searchLabel = this.dataService.res('Ubt-Document-Filter-Projects');
    //loadMessages(loadMessages);

    this.documentsColumnsHeader = [
      {
        caption: this.dataService.res('Ubt-Measure-List-Title'),
        dataField: 'FileName',
        dataType: 'string',
        width: '80%',
        visibleIndex: 0,
      },
      {
        caption: this.dataService.res('Ubt-Measure'),
        dataField: 'MeasureDesignation',
        visible: this.parentId === undefined,
        dataType: 'string',
        width: '80%',
        visibleIndex: 1,
      },
      {
        caption: this.dataService.res('Ubt-Document-Date'),
        dataField: 'Date',
        dataType: 'date',
        format: 'dd.MM.yyyy',
        minWidth: 100,
        visibleIndex: 2,
      },
      {
        type: 'buttons',
        caption: '',
        minWidth: 50,
        width: '50px',
        dataField: '',
        visibleIndex: 3,
      },
    ];
  }

  public ngOnInit(): void {
    this.appService.showLoader(true);
    this.dataService.floatingButtonConfig();
    this.dataService.uploadData$.subscribe((uploadData: GeoDsDocument) => {
      this.uploadDocument = uploadData;
    });

    this.dataService.updateGridData$.subscribe((document: GeoDsDocument) => {
      this.getDocumentByIdAndUpdate(this.documentService.documentColumns, document.Id);
    });

  }
  public onCellPrepared(e) {
    if (e.rowType === 'data' && e.column.type === 'buttons') {
      e.cellElement.style.cursor = 'pointer';
      e.cellElement.innerHTML = DefaultIcons.CONTEXTMENU;
    }
  }

  public onCellClick(e) {
    this.document = e.data;
    if (e.rowType === 'data' && e.column.type === 'buttons') {
      e.cellElement.className = 'context-menu-icon' + e.rowIndex;
      e.cellElement.innerHTML = this.contextMenu.visible ? DefaultIcons.CLOSE : DefaultIcons.CONTEXTMENU;
      this.contextMenuItems[1].visible = this.dataService.hasPermessionForSpecificModule('Documents', PermessionType.DELETE)
      this.contextMenu.target = '.context-menu-icon' + e.rowIndex;
      this.contextMenu.instance.show();
    }
  }
  public ngAfterViewInit(): void {
    const currentCompany = localStorage.getItem('currentCompany');

    if (!currentCompany) {
      this.handleNoCompanyCase();
      return;
    }
    if (this.parentId) {

      this.loadMeasureDetailsDocuments()
    }
    else {
      this.loadDocuments();
    }
  }

  private loadDocuments(): void {
    this.appService.showLoader(true);

    this.refreshDocuments().subscribe({
      next: (documents: GeoDsDocument[]) => this.handleDocumentsResponse(documents),
      error: () => this.handleDocumentsError(),
      complete: () => this.appService.showLoader(false)
    });
  }

  private handleDocumentsResponse(documents: GeoDsDocument[]): void {
    if (Array.isArray(documents) && documents.length > 0) {
      this.documents = documents.map(document => this.enrichDocumentDesignation(document));
      this.allDocuments = [...this.documents];
    }
    this.cdr.markForCheck();
  }

  private enrichDocumentDesignation(document: GeoDsDocument): GeoDsDocument {
    if (document['SubProjectDesignation']) {
      document['MeasureDesignation'] = `${document['SubProjectDesignation']}/${document['MeasureDesignation']}`;
    }
    return document;
  }

  private handleDocumentsError(): void {
    this.notificationService.callNotification({
      message: NotificationMessage.Error,
      type: ToastType.ERROR,
    });
  }

  private handleNoCompanyCase(): void {
    this.notificationService.callNotification({
      message: NotificationMessage.Empty,
      type: ToastType.INFO,
    });
    this.appService.showLoader(false);
    this.cdr.detectChanges();
  }

  private refreshDocuments(): Observable<GeoDsDocument[]> {
    const currentCompany = localStorage.getItem('currentCompany');

    if (this.measureDocumentList?.length > 0) {

      return this.getDocumentsForExistingMeasures(currentCompany);
    }

    return this.getDocumentsForNewMeasures(currentCompany);
  }

  private getDocumentsForExistingMeasures(currentCompany: string | null): Observable<GeoDsDocument[]> {
    const measures = [...this.measureDocumentList];
    if (currentCompany) {
      measures.push(currentCompany);
    }
    this.setOpath(measures);
    return this.documentService.getAllDocument(this.opath);
  }

  private getDocumentsForNewMeasures(currentCompany: string | null): Observable<GeoDsDocument[]> {

    return this.getMeasureDocumentsIds().pipe(
      switchMap((measures: string[]) => {

        if (currentCompany) {
          measures.push(currentCompany);
        }

        this.setOpath(measures);
        return this.documentService.getAllDocument(this.opath);
      })
    );
  }

  private setOpath(ids: string[]): void {
    this.opath = `ParentId in (${ids.map(id => `'${id}'`).join(', ')})`;

  }

  private getMeasureDocumentsIds(): Observable<string[]> {
    return this.documentService.getMeasureWithDocuments().pipe(
      map((measureData) => {
        if (Object.keys(measureData).length > 0) {
          this.measureDocumentList = measureData?.map(element => element?.Id);
        }
        return this.measureDocumentList;
      })
    );
  }



  public prepareProjectList = (): void => {
    this.documentService.getProjectList().subscribe(
      (_project) => {
        if (Array.isArray(_project) && _project.length > 0) {
          this.projectList = _project;
          this.cdr.markForCheck();
        }
      },
      (error) => {
        this.notificationService.callNotification({
          message: NotificationMessage.Error,
          type: ToastType.ERROR,
        });
        console.error(error);
      }
    );
  };

  public filterDocumentByProject = (event) => {
    this.appService.showLoader(true);
    const projecId = event.selectedItem?.Id;

    this.documentService.getDocumentsByProjectId(projecId).subscribe(
      (_projects) => {
        if (Array.isArray(_projects) && _projects.length > 0) {
          this.documents = _projects;
          this.isReset = true;
          this.cdr.markForCheck();
        }
      },
      (error) => {
        this.notificationService.callNotification({
          message: NotificationMessage.Error,
          type: ToastType.ERROR,
        });
        console.error(error);
      },
      () => {
        this.appService.showLoader(false);
      }
    );
  };



  private getDocumentByIdAndUpdate(columns: QueryColumn[], id: string) {
    const opath = 'Id=' + "'" + id + "'";
    this.documentService.getAllDocument(opath).subscribe(
      (data) => {
        if (Array.isArray(data) && data.length > 0) {
          this.documents.push(data[0]);
        }
        this.cdr.markForCheck();
        this.notificationService.callNotification({
          message: NotificationMessage.ValidUpdateMessage,
          type: ToastType.SUCCESS,
        });
      },
      (error) => {
        this.notificationService.callNotification({
          message: NotificationMessage.Error,
          type: ToastType.ERROR,
        });
        console.error(error);
      }
    );
  }

  private loadMeasureDetailsDocuments = (): void => {
    const opath = 'ParentId=' + "'" + this.parentId + "'";
    this.documentService.getAllDocument(opath).subscribe(
      (documents) => {
        if (Array.isArray(documents) && documents.length > 0) {
          this.documents = documents;
          this.cdr.markForCheck();
        }
      },
      (error) => {
        this.notificationService.callNotification({
          message: NotificationMessage.Error,
          type: ToastType.ERROR,
        });
        console.error(error);
      },
      () => {
        this.appService.showLoader(false);
      }
    );
  };
  public addDocument = () => {
    this.addDocumentPopup.instance.show();
  };

  public closeDocumentPopUp = () => {
    this.fileUploader.instance.reset();
    this.addDocumentPopup.instance.hide();
  };

  public onFileUpload(event, document): void {
    this.dataService.onFileChanged(event, document);
  }

  public uploadFile = (file) => {
    if (this.uploadDocument.Object.length !== 0) {
      this.uploadDocument.ParentId = this.parentId ? this.parentId.toString() : localStorage.getItem('currentCompany');
      this.uploadDocument.Designation = file.name.split('.')[0];
      this.uploadDocument.FileName = file.name;
      this.uploadDocument.Kind = DocumentKind.Datei;
      this.uploadDocument.ParentObjectType = ObjectKeys.DOCUMENT;
      this.dataService.persistUploadDocument(this.uploadDocument);
    }
  };

  public assginDocumentToMeasure(): void {
    //TODO: Assign doc to measure (parentId)
    // if (event.value) {
    //   this.documents.push(event.value);
    //   this.measureService.updateMeasure('MeasureDocuments', event.value);
    //   this.addDocumentSelectBox.instance.reset();
    // }
  }

  public downloadDocument = (id: string): void => {
    this.appService.showLoader(true);
    const opath = 'Id=' + "'" + id + "'";
    this.documentService.getAllDocument(opath, this.documentbyIdColumns).subscribe(
      (data) => {
        this.notificationService.callNotification({
          message: NotificationMessage.ValidInsertMessage,
          type: ToastType.SUCCESS,
        });
        this.dataService.downloadFile(new GeoDsDocument(data[0]));
        this.appService.showLoader(false);
      },
      (error) => {
        this.notificationService.callNotification({
          message: NotificationMessage.Error,
          type: ToastType.ERROR,
        });
        console.error(error);
        this.appService.showLoader(false);
      },
      () => {
        this.documentsGrid.instance.updateDimensions();
      }
    );
  };

  public removeRow(): void {
    this.documentService.deleteDocument(this.document.Id).subscribe(
      () => {
        this.notificationService.callNotification({
          message: NotificationMessage.ValidDeleteMessage,
          type: ToastType.SUCCESS,
        });
        this.deleteConfirmationPopup.instance.hide();
        const index = this.documents.findIndex((item) => item.Id === this.document.Id);
        this.documents.splice(index, 1);
        this.documentsGrid.instance.refresh();
      },
      (error) => {
        console.error(error);
        this.notificationService.callNotification({
          message: NotificationMessage.Error,
          type: ToastType.ERROR,
        });
      }
    );
  }

  public resetData(): void {
    this.documents = this.allDocuments;
    this.filterProjectList.value = null;
    this.appService.showLoader(false);
    this.isReset = false;
    this.cdr.markForCheck();
  }

  public openDeleteConfirmationDialog(): void {
    this.deleteConfirmationPopup.instance.show();
  }

  public abortDelete() {
    this.deleteConfirmationPopup.instance.hide();
  }

  public ngOnDestroy(): void {
    this.subscriptions.map((subscription) => subscription.unsubscribe());
  }
}
